/**
 * @file Handles DOM-related events
 * */
type ContentLoadedCallbackFunction = (event: Event) => void

const callbackQueue: ContentLoadedCallbackFunction[] = []
let isDomContentLoaded = false
let domConentLoadedEvent: Event

const domContentLoadedEvent = event => {
  isDomContentLoaded = true
  domConentLoadedEvent = event
  callbackQueue.forEach(callback => callback(event))
}
if (document.readyState === 'loading') {
  // Loading hasn't finished yet
  window.addEventListener('DOMContentLoaded', domContentLoadedEvent)
} else {
  // `DOMContentLoaded` has already fired.
  // This could happen if root Vue component (and/or subsequently this bit) is loaded asynchronously
  domContentLoadedEvent(new Event('DOMContentLoaded'))
}

function triggerOnContentLoaded(callback: ContentLoadedCallbackFunction): void {
  if (isDomContentLoaded) {
    callback(domConentLoadedEvent)
  } else {
    callbackQueue.push(callback)
  }
}

function isContentLoaded(): boolean {
  return isDomContentLoaded
}

export { triggerOnContentLoaded, isContentLoaded }
